<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row v-else>
      <!-- 테이블 -->
      <v-col cols="12" md="6">
        <paginated-table :data="announcements" :columns="tableColumns" :title="$t('title.announcement_management')"
          @updatePagination="updatePagination" />
      </v-col>

      <v-col cols="12" md="6">
        <editor-card :value="announcement.content" @update-content="updateContent">
          <template v-slot:header>
            <v-row align="center">
              <v-col class="d-flex flex-row">
                <label class="text-body-1 pa-2">{{ $t('label.title') }}</label>
                <v-text-field v-model="announcement.title" dense />
              </v-col>
            </v-row>
          </template>

          <template v-slot:bottom-buttons>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <custom-button @click="handleSubmit" :label="$t('button.save')" color="primary" size="lg" gradient
                rounded></custom-button>
            </v-card-actions>
          </template>
        </editor-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EditorCard from "@/components/common/Cards/EditorCard.vue";
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import { getAnnouncementColumns } from "@/views/ContentView/columns";
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { announcementLabel } from "@/views/ContentView/label";
import { deleteAnnouncementPopup, success, savePopup } from '@/views/ContentView/popups';
import { boardApi } from "@/api/api";

export default {
  components: {
    PaginatedTable,
    CustomButton,
    EditorCard,
    LoadingSpinner,
  },
  data() {
    return {
      titles: announcementLabel.titles,
      buttons: announcementLabel.buttons,

      contentIsLoaded: true,
      isLoading: false,
      tableColumns: getAnnouncementColumns({
        edit: this.handleEdit,
        delete: this.handleDelete,
      }),

      boardIdx: 1,
      announcements: {
        page_info: { page: 1, size: 5, total_elements: 5, total_pages: 1 },
        elements: [],
      },
      announcement: { board_idx: this.boardIdx, idx: null, title: '', content: '' }
    };
  },
  methods: {
    handleEdit(post) {
      this.fetchAnnouncement(post);
    },
    async handleDelete(post) {
      const isConfirmed = await deleteAnnouncementPopup(post);
      if (!isConfirmed) return;
      if (await this.deletePost(post)) {
        await this.fetchAnnouncements();
        await success();
      }
    },
    async handleSubmit() {
      if (!(await savePopup())) return;

      this.contentIsLoaded = false;
      this.$set(this.announcement, 'board_idx', this.boardIdx);

      const saveAction = this.announcement.idx == null
        ? this.createAnnouncement(this.announcement)
        : this.updateAnnouncement(this.announcement);

      saveAction.then((success) => {
        if (success) {
          this.initAnnouncement();
          this.fetchAnnouncements();
        }
      }).finally(() => {
        this.contentIsLoaded = true;
      });
    },
    initAnnouncement() {
      this.announcement = { board_idx: this.boardIdx, idx: null, title: '', content: '' };
    },
    async fetchAnnouncements() {
      this.isLoading = true;
      try {
        const response = await boardApi.getPosts({
          board_idx: this.boardIdx,
          size: this.announcements.page_info.size,
          page: this.announcements.page_info.page,
        });
        if (response.status === 200) {
          this.announcements = response.data.response;
          this.isLoading = false;
        }
      } catch {
        this.isLoading = false;
      }
    },
    async fetchAnnouncement(post) {
      this.isLoading = true;
      try {
        const response = await boardApi.getPost(post);
        if (response.status === 200) {
          this.announcement = response.data.response;
          this.isLoading = false;
        }
      } catch {
        this.isLoading = false;
      }
    },
    async createAnnouncement(post) {
      try {
        return (await boardApi.createPost(post)).status === 201;
      } catch {
        return false;
      }
    },
    async updateAnnouncement(post) {
      try {
        return (await boardApi.updatePost(post)).status === 200;
      } catch {
        return false;
      }
    },
    async deletePost(post) {
      try {
        return (await boardApi.deletePost(post)).status === 204;
      } catch {
        return false;
      }
    },
    updateContent(newValue) {
      this.announcement.content = newValue;
    },
    updatePagination(pagination) {
      this.announcements.page_info.size = pagination.size;
      this.announcements.page_info.page = pagination.page;
      this.fetchAnnouncements();
    },
  },
  mounted() {
    this.fetchAnnouncements();
  },
};
</script>

<style scoped></style>
